<template>
  <v-toolbar
    :class="{
      'bc-outlined-gray bb-1': outlined,
      'pb-2': !$slots.append,
    }"
    :elevation="flat ? 0 : 2"
    :height="smallDisplay ? '90' : 'default'"
    data-cy="page-title"
  >
    <template v-if="title">
      <TitleBar
        @create="$emit('create')"
        :back-back-name="backBackName"
        :back-back-route="backBackRoute"
        :back-name="backName"
        :back-route="backRoute"
        :create-icon="createIcon"
        :create-text="createText"
        :createable="createable"
        :name="title"
        :small-display="smallDisplay"
        :title-only="titleOnly"
        class="px-3"
        dense
      >
        <template
          v-if="$slots.append"
          #append
        >
          <slot name="append" />
        </template>

        <template
          v-if="$slots['inline-actions']"
          #inline-actions
        >
          <slot name="inline-actions" />
        </template>

        <template
          v-if="$slots.actions"
          #actions
        >
          <slot name="actions" />
        </template>
      </TitleBar>
    </template>

    <template v-else>
      <slot />
    </template>

    <template
      v-if="$slots.extension"
      #extension
    >
      <slot name="extension" />
    </template>
  </v-toolbar>
</template>

<script setup>
import TitleBar from '@/shared/components/TitleBar.vue';

defineProps({
  backBackName: {
    type: String,
    default: null,
  },
  backBackRoute: {
    type: Object,
    default: null,
  },
  backName: {
    type: String,
    default: null,
  },
  backRoute: {
    type: Object,
    default: null,
  },
  createable: {
    type: Boolean,
    default: false,
  },
  createIcon: {
    type: String,
    default: 'add',
  },
  createText: {
    type: String,
    default: null,
  },
  flat: {
    type: Boolean,
    default: true,
  },
  outlined: {
    type: Boolean,
    default: false,
  },
  smallDisplay: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: null,
  },
  titleOnly: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['create']);
</script>
